import type { ErrorKind } from '@/shared/model/types/error';

export const NETWORK_ERROR = 'Нет связи с сервером. Проверьте подключение к интернету';
export const AUTH_ERROR = 'Требуется вход в аккаунт';
export const FORBIDDEN_ERROR = 'Недостаточно прав для этого действия';
export const NOT_FOUND_ERROR = 'Данные не найдены';
export const VALIDATION_ERROR = 'Проверьте правильность заполнения полей';
export const SERVER_ERROR = 'Сервис временно недоступен. Попробуйте позже';
export const UNKNOWN_ERROR = 'Что-то пошло не так. Попробуйте позже';

export const ERROR_MESSAGE_BY_KIND: Record<ErrorKind, string> = {
  network: NETWORK_ERROR,
  auth: AUTH_ERROR,
  forbidden: FORBIDDEN_ERROR,
  notFound: NOT_FOUND_ERROR,
  validation: VALIDATION_ERROR,
  server: SERVER_ERROR,
  unknown: UNKNOWN_ERROR,
};

export const NO_RESPONSE_STATUS = 0;
export const CONFLICT_STATUS = 409;
export const VALIDATION_STATUS = 422;

export const ERROR_PAGE_NOT_FOUND_TEXT =
  'Такой страницы не существует. Попробуйте поискать на главной';
export const ERROR_PAGE_SERVER_TEXT =
  'Не удалось загрузить страницу. Мы уже знаем о проблеме — попробуйте обновить';
export const ERROR_PAGE_SERVER_TITLE = 'Ошибка сервера';
export const ERROR_PAGE_HOME_BUTTON = 'На главную';
